import { z } from "zod";

export const signatureSchema = z.object({
    id: z.coerce.string().default(""),
    url: z.string(),
    type: z.string().default(""),
    name: z.string().default(""),
});

export const discountCodeSchema = z.object({
    id: z.coerce.string().default(""),
    code: z.string(),
    percentage: z.number(),
});

export const orderProductSchema = z.object({
    id: z.coerce.string().default(""),
    productId: z.coerce.string(),
    sunProtectionProductId: z.coerce.string(),
    productType: z.enum(["SUN_PROTECTION", "WINDOW_DECORATION"]),
    colorId: z.coerce.string(),
    frameColorId: z
        .string()
        .nullish()
        .transform((v) => v ?? null),
    controlType: z
        .enum(["REMOTE", "APP"])
        .nullish()
        .transform((v) => v ?? null),
});

export const sunProtectionOrderSchema = z.object({
    id: z.coerce.string().default(""),
    dealId: z.coerce.number().default(0),
    measurementFormSigned: z.boolean().default(false),
    signature: signatureSchema.nullish().transform((v) => v ?? null),
    discountCode: discountCodeSchema.nullish().transform((v) => v ?? null),
    products: z.array(orderProductSchema).default([]),
    createdAt: z
        .string()
        .nullish()
        .transform((v) => v ?? ""),
    updatedAt: z
        .string()
        .nullish()
        .transform((v) => v ?? ""),
});

export const orderResponseSchema = z.object({
    getSunProtectionOrder: sunProtectionOrderSchema.nullish(),
});

export const orderByIdResponseSchema = z.object({
    getSunProtectionOrderById: sunProtectionOrderSchema.nullish(),
});
